import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ReportGeneratorTokenResponse {
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class ReportGeneratorTokenService {
  constructor(private http: HttpClient) {}

  getToken(): Observable<ReportGeneratorTokenResponse> {
    return this.http.post<ReportGeneratorTokenResponse>('api/token', {});
  }
}
